export const VERIFICATION_METHODS = {
    SMS: "VERIFICATION_METHOD_SMS",
    EMAIL: "VERIFICATION_METHOD_EMAIL",
    DOCUMENTS: "VERIFICATION_METHOD_DOCUMENTS",
    ADMIN: "VERIFICATION_METHOD_ADMIN"
}
